import { render, staticRenderFns } from "./OtherLoanSelection.vue?vue&type=template&id=6bf95b0b"
import script from "./OtherLoanSelection.vue?vue&type=script&lang=js"
export * from "./OtherLoanSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports